import React, { useMemo, useState } from 'react';

const sanitizeSvg = (symbol) => {
    if (typeof symbol !== 'string') {
        return null;
    }

    const trimmed = symbol.trim();
    if (!trimmed.startsWith('<svg')) {
        return null;
    }

    return trimmed
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
        .replace(/\son\w+=("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
        .replace(/javascript:/gi, '');
};

const normalizeLogoUrl = (logo) => {
    if (typeof logo !== 'string') {
        return '';
    }

    const trimmed = logo.trim();
    if (!trimmed) {
        return '';
    }

    return trimmed;
};

const IntegrationSymbol = ({ symbol, logo, fallback = '🔌', className = '' }) => {
    const svgMarkup = sanitizeSvg(symbol);
    const logoSrc = useMemo(() => normalizeLogoUrl(logo), [logo]);
    const [logoFailed, setLogoFailed] = useState(false);
    const classes = `integration-symbol-render ${className}`.trim();

    if (logoSrc && !logoFailed) {
        return (
            <img
                src={logoSrc}
                alt=""
                className={`${classes} integration-symbol-logo`.trim()}
                loading="lazy"
                onError={() => setLogoFailed(true)}
            />
        );
    }

    if (svgMarkup) {
        return (
            <span
                className={classes}
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: svgMarkup }}
            />
        );
    }

    return (
        <span className={`${classes} integration-symbol-fallback`.trim()} aria-hidden="true">
            {symbol || fallback}
        </span>
    );
};

export default IntegrationSymbol;
